import React, { useState } from "react"
import { Button, Card, Descriptions, Input, Select, Space, message } from "antd"
import { Client } from "../../../../models/client"
import { ClientRole } from "../../../../services/client-role-service"
import { CopyOutlined, FormOutlined } from "@ant-design/icons"

type Props = {
  groupInfo: {
    name: string
    description: string
    notes: string
  }
  clients: Client[]
  selectedClient: string | null
  onClientChange: (clientId: string | null) => void
  clientRoles: ClientRole[]
  currentActiveClientRoles: string[]
  selectedClientRoles: string[]
  selectedClientTextRoles: string[]
  onSelectClientRoles: (clientRoles: string[]) => void
  onSelectClienTexttRoles: (clientRoles: string[]) => void
  onSave: (clientId: string, clientRoles: string[]) => void
  onSaveClientTextRoles: (clientId: string, clientRoles: string[]) => void
}

const { TextArea } = Input

export const isArrayElementsUnchanged = (leftHandSide: any[], rightHandSide: any[]) => {
  const rightHandSizeSet = new Set(rightHandSide)
  return leftHandSide.length === rightHandSide.length && leftHandSide.every((element) => rightHandSizeSet.has(element))
}

export const GroupInfo: React.FC<Props> = ({
  groupInfo,
  clients,
  selectedClient,
  onClientChange,
  clientRoles,
  selectedClientRoles,
  selectedClientTextRoles,
  onSelectClientRoles,
  onSelectClienTexttRoles,
  onSave,
  onSaveClientTextRoles,
}): React.ReactElement => {
  console.log("groupInfo", groupInfo)
  const { name, description, notes } = groupInfo
  const [placeClipboard, setPlaceClipboard] = useState<string[]>([])
  return (
    <Descriptions bordered>
      <Descriptions.Item label="Name" span={3}>
        {name}
      </Descriptions.Item>
      <Descriptions.Item label="Description" span={3}>
        {description}
      </Descriptions.Item>
      <Descriptions.Item label="Notes" span={3}>
        {notes}
      </Descriptions.Item>
      <Descriptions.Item label="Roles" span={3}>
        <Space.Compact style={{ width: "100%", paddingBottom: "10px" }}>
          <Select
            onDeselect={() => onClientChange(null)}
            value={selectedClient}
            onChange={onClientChange}
            style={{ width: 300 }}
          >
            {clients.map((client) => (
              <Select.Option key={client.id} value={client.id}>
                {client.name}
              </Select.Option>
            ))}
          </Select>
        </Space.Compact>

        <Space.Compact style={{ width: "100%", paddingBottom: "10px" }}>
          <Select
            mode="multiple"
            placeholder="Please select roles"
            allowClear
            value={selectedClientRoles}
            style={{ width: "80%" }}
            filterOption={(input, option) => {
              return (option?.label?.toString() ?? "").includes(input)
            }}
            onChange={(newValue: string[] | string) => {
              console.log("onChange", { newValue })
              const newValueArray = typeof newValue === "string" ? [newValue] : newValue
              onSelectClientRoles(newValueArray)
            }}
            options={clientRoles.map(({ id, name, description }) => ({ value: id, label: `${description}` }))}
          />
          <Button
            onClick={async () => {
              navigator.clipboard.writeText(
                `${clientRoles
                  .filter(({ id, name, description }) => selectedClientRoles.includes(id))
                  .map(({ id, name, description }) => description)}`
              )
              setPlaceClipboard(
                clientRoles
                  .filter(({ id, name, description }) => selectedClientRoles.includes(id))
                  .map(({ id, name, description }) => description)
              )
              message.success(
                `copy: ${clientRoles
                  .filter(({ id, name, description }) => selectedClientRoles.includes(id))
                  .map(({ id, name, description }) => description)}`
              )
            }}
          >
            copy <CopyOutlined />
          </Button>
        </Space.Compact>
        <Space.Compact style={{ width: "100%", paddingBottom: "10px" }}>
          <TextArea
            placeholder="role1,role2,role3"
            allowClear
            style={{ width: "80%" }}
            value={selectedClientTextRoles}
            rows={1}
            onChange={(value) => {
              const newValueArray =
                typeof value.target.value === "string" ? value.target.value.split(",") : value.target.value
              onSelectClienTexttRoles(newValueArray)
            }}
          />
          <Button
            onClick={() => {
              onSelectClienTexttRoles(placeClipboard)
            }}
          >
            paste <FormOutlined />
          </Button>
        </Space.Compact>
        <Space.Compact style={{ width: "100%", paddingBottom: "10px" }}>
          <Button
            type="primary"
            onClick={() => selectedClient && onSaveClientTextRoles(selectedClient, selectedClientTextRoles)}
          >
            Submit
          </Button>
        </Space.Compact>
        <Button onClick={() => selectedClient && onSave(selectedClient, selectedClientRoles)}>Save</Button>
      </Descriptions.Item>
    </Descriptions>
  )
}
